import React, { useEffect } from 'react';

const WIDGET_SRC = 'https://elfsightcdn.com/platform.js';
const WIDGET_CLASS = 'elfsight-app-95b00b23-c5c9-4f18-b917-ec80332a31a3';

export default function ElfsightReviewsSection() {
  useEffect(() => {
    // Inject Elfsight script une seule fois
    if (!document.querySelector(`script[src="${WIDGET_SRC}"]`)) {
      const script = document.createElement('script');
      script.src = WIDGET_SRC;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section data-testid="reviews-section" className="py-20 bg-[#050509] border-t border-[#C9A24D]/10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-[#F5F5F5] mb-4">
            Avis de nos clients sur{' '}
            <span className="text-[#C9A24D]">Google</span>
          </h2>
          <p className="text-[#A7A7A7] text-sm sm:text-base">
            Les derniers avis laissés sur <span className="text-[#C9A24D]">Google</span> pour Y GO, votre service VTC au Havre et en Normandie.
          </p>
        </div>
        <div className="bg-transparent p-0 sm:p-0">
          <div className={`${WIDGET_CLASS}`} data-elfsight-app-lazy />
        </div>
      </div>
    </section>
  );
}
